export const downloadURI = (uri: string, fileName: string) => {
  const link = document.createElement('a');
  link.download = fileName;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  try {
    URL.revokeObjectURL(link.href);
    link.remove();
  } catch (e) {
    console.warn('Error while cleaning up file download resources:', e);
  }
};
